import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { ForbiddenPage } from '@/components/account'

/** A1b — dignified terminal for removed / archived-out / wrong-workspace. */
export const Route = createFileRoute('/_ws/no-access')({
  component: NoAccessPage,
})

function NoAccessPage() {
  const navigate = useNavigate()
  return (
    <ForbiddenPage
      reason="removed"
      onAction={() => void navigate({ to: '/workspaces' })}
    />
  )
}
